import { render, staticRenderFns } from "./ExpenseConfigTable.vue?vue&type=template&id=2c55d78d&scoped=true&"
import script from "./ExpenseConfigTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseConfigTable.vue?vue&type=style&index=0&id=2c55d78d&lang=scss&scoped=true&"
import style1 from "./ExpenseConfigTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ExpenseConfigTable.vue?vue&type=style&index=2&id=2c55d78d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55d78d",
  null
  
)

export default component.exports